import React from "react";
import Link from "next/link";
import { footerAdditionLink } from "@/src/shared/constants/app";

const AboutLinks: React.FC = () => (
  <div>
    <h2 className="text-ink-black mb-4 font-semibold text-lg">Quick Links</h2>
    <ul className="space-y-3">
      {footerAdditionLink.map((item) => (
        <li key={item.label}>
          <Link
            href={item.href}
            className="text-ink-secondary hover:text-ink-black text-sm"
          >
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default AboutLinks;
